import { Component, Inject, Input, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { loadStripe } from '@stripe/stripe-js';
import { environment } from '../../../environments/environment';

import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { ClientCreditsService } from 'src/app/services/apiclient/clientcredits/clientcredits.service';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { TranslateService } from '@ngx-translate/core';
import { LangagesService } from 'src/app/services/manage/langages/langages.service';
import { CssService } from '../../services/css-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type CommMessage =
  | { type: 'paymentIntent'; data: any }
  | { type: 'confirm'; data: any }
  | { type: 'error'; error: any };

@Component({
  selector: 'app-stripe-web',
  templateUrl: './stripe-web.component.html',
  styleUrls: ['./stripe-web.component.css'],
})
export class StripeWebComponent implements OnInit {
  // @Input() data: any;

  private comm$!: Subject<CommMessage>;
  private commSub!: Subscription;

  // stripe
  stripe: any;
  clientSecret: any;
  elements: any;
  paymentElement: any;

  layout_tabs: any = {
    type: 'tabs',
    defaultCollapsed: false,
  };

  PaymentMethodOrder: any = ['card', 'bancontact'];
  formIsLoading = false;
  spinnerPayIsLoading = false;

  currPOS: any = this.tools.getStor('point_of_sale');
  amount: any;
  loader = false;
  payment_type: any;
  id_user: any;
  currency: { symbol: string; code: string; decimal: string } | null = null;
  metadata_provenance: any;
  dataOrder: any;
  dataCredit: any;
  dataRefill: any;
  merchantClient: any;
  error: any = null;
  checkOpenPof: any;
  paymentIntentId: any;
  pof_id: any;

  uberFee = 0;
  dataParams: any;

  constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
            private dialogRef: MatDialogRef<StripeWebComponent>,
    private myStripeApi: MyStripeService,
    private tools: ToolsService,
    public cssService: CssService,
    private orderApi: ClientOrdersService,
    public myDials: DialogsService,
    private clientCreditsService: ClientCreditsService,
    private refillsApi: ClientRefillsService,
    public translate: TranslateService,
    public langagesService: LangagesService
  ) { }

  ngOnInit(): void {
    this.formIsLoading = true;
      console.log('stripe-web.component - ngOnInit -  @Input() data : ', this.data);

    if (!this.data) {
      console.error('stripe-web.component - missing @Input() data');
      this.formIsLoading = false;
      return;
    }

    this.initFromData(this.data);

    if (this.comm$) {
      this.commSub = this.comm$
        .pipe(filter(m => m.type === 'confirm' || m.type === 'error'))
        .subscribe((msg: any) => {
          if (msg.type === 'confirm') {
            this.setInfoPaymentElements(msg.data);
          } else if (msg.type === 'error') {
            // this.error = msg.error;
          }
        });
    }

    this.onInit();
  }

  private initFromData(data: any): void {
    if (data.comm$) this.comm$ = data.comm$;

    this.amount = data.amount;
    this.id_user = data.id_user ?? null;
    this.dataOrder = data.dataOrder ?? null;
    this.dataCredit = data.dataCredit ?? null;
    this.dataRefill = data.dataRefill ?? null;
    this.metadata_provenance = data.metadata;

    if (data.clientSecret) this.clientSecret = data.clientSecret;
    if (data.paymentIntentId) this.paymentIntentId = data.paymentIntentId;

    if (this.metadata_provenance == 2 || this.metadata_provenance === '2' || this.metadata_provenance === 'credit') {
      this.pof_id = data.currpos?.key;
    } else if (this.metadata_provenance == 3 || this.metadata_provenance === '3' || data.flow === 'refill') {
      this.metadata_provenance = 3;
      this.pof_id = null;
    } else if (this.currPOS?.id) {
      this.pof_id = this.currPOS.id;
    } else {
      console.error('stripe-web.component - this.pof_id null and provenance is not refill');
    }

    this.merchantClient = data.merchantClient ?? null;
    this.checkOpenPof = data.checkOpenPof ?? null;
    this.stripe = data.stripe;
    this.uberFee = data.uber ? data.uber.fee : null;
  }




  /**
   * @description pre initialise Stripe en cas de changement
   */
  onInit() {
    this.error = null;
    // Sécurité, on détruit l'element si déja initialisé
    if (this.paymentElement) {
      this.paymentElement.unmount();
    }
    // Récupération de la clé Stripe (prod ou test selon le client)
    this.myStripeApi.getStripeKey().subscribe(async key => {
      // console.log("getStripeKey", key)

      //TODO tout le temps passer par la a terme
      if (!this.stripe) {
        if (this.metadata_provenance == 4) {
          if (!key) {
            key = environment.stripe.stripePublicKey;
          }
        }
        this.stripe = await loadStripe(key);
      }

      // Initialisation du composant Stripe
      if (key) {
        this.initializeStripe();
      }
    });
  }

  /**
   * @description initialise Stripe
   */
  initializeStripe() {
    //no order_id   metadata_provenance == 1
    const order_id = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
    //get payintent stripe
    const metaprov = parseInt(this.metadata_provenance);
    let key: string | null = null;
    // (1 = of Order, 2= of Credit=2 ,3= of Refill, 4 = payment note )
    switch (metaprov) {
      case 1:
        key = this.tools.getStor("ClientKeyPayIntentOrder");
        break;
      case 2:
        key = this.tools.getStor("ClientKeyPayIntentCredit");
        break;
      case 3:
        key = this.tools.getStor("ClientKeyPayIntentRefill");
        break;
      default:
        key = null;
        break;
    }
    const KeyPayIntent = key || null;
    if (!order_id && metaprov == 1) {
      this.tools.openSnackBar(this.translate.instant('stripeErrors.error'), ['warn'], 4000);
      console.error("stripeErrors.error");
      this.closeDial();
      return;
    }

    // New flow: FulleRecharge (refill) already has a PaymentIntent + clientSecret,
    // we do NOT want to call getClientKeyPayIntent again, we just mount the element.
    if (metaprov === 3 && this.clientSecret && this.paymentIntentId) {
      this.mountPaymentElements();
      return;
    }

    //check KeyPayIntent
    KeyPayIntent ? this.getPayintentPaiement(KeyPayIntent) : this.getClientKeybyPayIntent();
  }

  /**
   * Récupération d'une intention de paiement existante
   * @param KeyPayIntent intention de paiement
   */
  getPayintentPaiement(KeyPayIntent: any) {
    this.myStripeApi.getPayintentPaiement(KeyPayIntent.paymentIntent.id).subscribe((data: any) => {
      // console.log("data : ", data);
      if (data && data.code == 500) {
        const error = {
          error: "errorpayintent"
        }
        this.errorStripe(null, error);
        return;
      }

      if (data && data.status === "succeeded") {
        // console.log("getPayintentPaiement -> PaymentIntent déjà payé (succeeded)");

        // on nettoie la clé liée au PayIntent
        this.clearPayIntentStorage();

        // on renvoie un "succès" au parent, pas une erreur
        this.closeDial({
          status: "succeeded",
          alreadyPaid: true,
          paymentIntent: data,
        });
        return;
      }

      if (data && data.status === "canceled") {
        // console.log("getPayintentPaiement -> PaymentIntent canceled, on recrée une intent propre");
        this.clearPayIntentStorage();
        this.getClientKeybyPayIntent();
      } else {
        this.getClientKeybyPayIntent(KeyPayIntent);
      }
    })
  }

  /**
   * @description recupere la clé client pour creer l'element stripe
   */
  getClientKeybyPayIntent(KeyPayIntent?: any) {
    this.myStripeApi.getClientKeyPayIntent(
      this.amount,
      false,
      parseInt(this.metadata_provenance),
      this.id_user,
      this.pof_id,
      KeyPayIntent ? KeyPayIntent.paymentIntent.id : null
    )
      .subscribe({
        next: async (data: any) => {
          if (!data) return;

          // Erreur renvoyée par l'API (structure maison)
          if (data.err || (data.code && data.code < 0)) {
            this.errorStripe(data);
            return;
          }

          if (this.comm$) {
            this.comm$.next({ type: 'paymentIntent', data });
          } else {
            this.setInfoPaymentElements(data);
          }
        },

        // 🔥 Gestion des erreurs réseau / serveur (HTTP 500, 400, etc)
        error: (err: any) => {
          console.error('Erreur Stripe (HTTP)', err);

          // Essaye d’extraire un message utile
          const backendMsg =
            err?.error?.message ||
            err?.error?.error ||
            err?.message ||
            'Une erreur serveur est survenue.';

          // Affichage via ta méthode interne
          this.errorStripe({
            err: true,
            message: backendMsg,
          });
        }
      });
  }


  errorStripe(data?: any, error?: any) {
    //this.spinnerIsLoading = false;
    this.loader = false;
    this.spinnerPayIsLoading = false;
    const datamessage = data && data.err && data.err.jsonBody && data.err.jsonBody.error && data.err.jsonBody.error.message ? data.err.jsonBody.error.message : null
    this.handleError(datamessage, 5000);
    console.error("handleError");
    this.closeDial(error);
  }

  /**
   * @description set Info Payment Element and set localstorage
   */
  setInfoPaymentElements(data: any) {
    const metaprov = parseInt(this.metadata_provenance);
    this.tools.removeStor("ClientKeyPayIntenCard");
    //set payintent stripe web
    this.clientSecret = data.paymentIntent.client_secret;
    this.paymentIntentId = data.paymentIntent.id;
    let setLocastorage;
    switch (metaprov) {
      case 1:
        setLocastorage = "ClientKeyPayIntentOrder";
        break;
      case 2:
        setLocastorage = "ClientKeyPayIntentCredit";
        break;
      case 3:
        setLocastorage = "ClientKeyPayIntentRefill";
        break;
      case 4:
        setLocastorage = "ClientKeyPayIntentNote";
        break;
      default:
        setLocastorage = null;
    }
    //set storage and mount element
    if (setLocastorage) {
      this.tools.setStor(setLocastorage, data);
      this.currency = data.currency;
      this.mountPaymentElements();
    }
  }

  /**
   * @description Creation de l'element de Payment Stripe
   */
  async mountPaymentElements() {
    // let lang=this.LangagesService.getInternetLang()
    const lang = this.langagesService.getLang();
    const options = {
      clientSecret: this.clientSecret,
      appearance: {
        theme: 'flat', //stripe  night   flat   none
        labels: 'floating',
      },
      locale: lang,
    };
    //on set les elements stripe avec options
    this.elements = this.stripe.elements(options);
    //on cree un element payment avec les options
    const paymentElementOptions = {
      layout: this.layout_tabs,
      paymentMethodOrder: this.PaymentMethodOrder
    };
    // Sécurité : On détruit l'ancien element de paiement si existant
    if (this.paymentElement) {
      this.paymentElement.unmount();
    }
    // instance of the Payment Element
    this.paymentElement = this.elements.create("payment", paymentElementOptions);
    this.paymentElement.mount("#payment-element");
    //this.myStripeApi.setpaymentElement(this.paymentElement);
    // set listener
    this.setEventListener();
    //see button pay
    this.initPayButton();
    this.formIsLoading = false;
  }

  /**
   * @description affichage du bouton pay
   */
  initPayButton(): void {
    /*// evite que le boutton submit arrive avant la frame
    let timeout = this.paymentElement ? 2000 : 0;
    setTimeout(() => {
      this.spinnerIsLoading = false;
    }, timeout);
  
    setTimeout(() => {
      this.spinnerIsLoading = false;
    }, timeout);*/
  }

  // Créer une commande et  submit pay
  // TODO il va falloir alléger et fluidifer cette méthode
  async submitOrder(e: any, order_id_device?: any) {
    e.preventDefault();
    if (!this.stripe) {
      return;
    }
    //error
    const { error: submitError } = await this.elements.submit();
    if (submitError) {
      return;
    }
    // setLoading
    this.spinnerPayIsLoading = true;
    // medata provenance string   (1 = of Order, 2= of Credit=2 ,3= of Refill )
    if (this.metadata_provenance == 1 || this.metadata_provenance == '1') {
      this.orderApi.checkError(
        this.dataOrder.orderCard,
        this.dataOrder.billingAddress,
        this.dataOrder.delivryAddress,
        this.dataOrder.selectedRelay,
        this.dataOrder.isRelay,
        this.uberFee > 0 ? this.uberFee / 100 : 0,
        // this.amount
      ).then(async (data) => {
        // console.log("fulle-stripe-web.component - submitOrder - this.uberFee / 100 : ", this.uberFee / 100)
        // Si erreur
        if (data) {
          setTimeout(() => {
            if (data === "invalidDateproduct") {
              //actualise la page
              setTimeout(() => {
                window.location.reload();
                this.closeDial();
              }, 1000);
            }
          });
          /* Si aucune erreur alors on crée la commande */
        } else {
          this.orderApi.checkOrderAmount(
            this.dataOrder.billingAddress, // billingAddress
            this.dataOrder.delivryAddress, //delivryaddress
            (this.dataOrder.isRelay ? this.dataOrder.selectedRelay : null), // relay
            this.merchantClient, // merchantClient
            this.checkOpenPof, // checkopenpof
            this.uberFee / 100 // uberFee
          ).then((val: any) => {
            if (val.code === 0 && val.amount == this.amount) {
              //creation commande et paiement (sauf stripe paiement)
              this.orderApi.submitOrder(
                true, // payment_type
                this.dataOrder.orderCard, // currCard
                this.dataOrder.billingAddress, // billingAddress
                this.dataOrder.delivryAddress, // delivryaddress
                (this.dataOrder.isRelay ? this.dataOrder.selectedRelay : null), // relay
                null, // paypal_order_id
                this.dataOrder.payment_intent_id, // payment_intent_id
                this.merchantClient, // merchantClient
                this.paymentIntentId, // paymentIntentId
                order_id_device, // order_id_device
                null, // url
                null, // payment_intent_id_saved
                this.uberFee / 100 // uberFee
              ).then(
                data => {
                  // console.log("fulle-stripe-web.component - submitOrder - data : ", data)
                  if (data.code === -6 && data.order_id) {
                    /* Success */
                    this.tools.setStor("payment_save_order_stripe", {
                      order_id: data.order_id,
                      payment_intent: this.paymentIntentId
                    });
                    this.PaymentStripe();
                  } else {
                    /* Erreur */
                    if (data && data.code && data.code === -134) {
                      this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
                      console.error("credit_due.nogoodPayMethod");
                      this.closeDial();
                    }
                    if (data && data.code && data.code === -100) {
                      const error = {
                        error: "errorYetPayed"
                      }
                      console.error("error errorYetPayed");
                      this.closeDial(error);
                    } else {
                      this.handleError(data.message);
                    }
                  }
                }
              );
            } else {
              /* On affiche un message d'erreur */
              this.handleError();
            }
          }).catch(() => {
            this.handleError();
          });
        }
      })
    }
    // Paiement débiteurs
    else if (this.metadata_provenance == 2 || this.metadata_provenance == '2') {
      this.clientCreditsService.creditCard(this.dataCredit.credit_pay_intent,
        this.dataCredit.currCard$, 'null',
        this.dataCredit.payment_intent_id, this.paymentIntentId).then(
          data => {
            if (data.code === -6 && data.lettering_intent_id) {
              /* Success */
              this.tools.setStor("payment_credit_stripe_payment", {
                lettering_intent_id: data.lettering_intent_id,
                payment_intent: this.paymentIntentId
              });
              this.PaymentStripe();
            } else {
              /* Erreur */
              this.handleError(data.message);
            }
          }
        );
    }
    // Recharge cagnotte
    else if (this.metadata_provenance == 3 || this.metadata_provenance == '3') {
      //creation advance_payment et paiement  stripe paiement
      this.refillsApi.refillsStripePayment(this.amount, this.id_user, this.paymentIntentId).then(
        data => {
          /* Success */
          // console.log("fulle-stripe-web.component - submitOrder - provenance 3 - refillsStripePayment data : ", data);
          if (data.code === 0 && data.client_recharge.id) {
            this.tools.setStor("payment_save_recharge_stripe", {
              client_recharge_id: data.client_recharge.id,
              payment_intent: this.paymentIntentId
            });
            this.PaymentStripe();
          }
          /* Erreur */
          else {
            this.handleError(data.message);
          }
        }
      );
    }
    // Paiement note
    else if (this.metadata_provenance == 4) {
      await this.PaymentStripe();
    }
  }

  /**
   * @description PaymentStripe
   */
  async PaymentStripe() {
    //error
    const { error: submitError } = await this.elements.submit();
    if (submitError) {
      this.spinnerPayIsLoading = false;
      return;
    }
    // const url = window.location.origin + window.location.pathname
    // Use the clientSecret and Elements instance to confirm the setup
    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      clientSecret: this.clientSecret,
      //TODO retester avec 3d secure
      redirect: 'if_required',
      confirmParams: {
        //return_url: url, //redirige apres payement...
      }
    });
    this.spinnerPayIsLoading = false;
    //error confirm
    if (error && (error.type === "card_error" || error.type === "validation_error")) {
      this.handleError(error.message);
      return;
    }
    //status
    const { paymentIntent } = await this.stripe.retrievePaymentIntent(this.clientSecret);
    switch (paymentIntent.status) {
      case "succeeded":
        this.closeDial({
          paymentIntent: paymentIntent
        });
        break;
      case "processing":
        // this.showMessage("");
        break;
      case "requires_payment_method":
        this.handleError(null, null, "abon");
        break;
      default:
        this.handleError();
        break;
    }
  }

  /**
   * @description Error
   */
  handleError(data?: any, time?: any, abon?: any) {
    const t = time ? time : 8000;
    const message = data ? data : this.translate.instant('loginComp.error');
    if (!abon) {
      this.tools.openSnackBar(message, "warn", t);
    }
    console.error("handleError openSnackBarr");
    this.closeDial();
  }

  /**************** elements events **************/
  setEventListener() {
    // on ready

    this.paymentElement.on('ready', function (event: any) {
      if (event.complete) {
        // enable payment button
      }
    });

    //on change
    this.paymentElement.on('change', function (event: any) {
      // that.payment_type = event.value.type;
      if (event.complete) {
        // enable payment button
      }
    });
    // on focus
    this.paymentElement.on('focus', function (event: any) {
      if (event.complete) {
        // enable payment button
      }
    });
    // on blur
    this.paymentElement.on('blur', function (event: any) {
      if (event.complete) {
        // enable payment button
      }
    });
    this.paymentElement.on('loaderstart', function () {
      // Handle loaderstart event
    });
    this.paymentElement.on('loaderror', function () {
      // Handle loaderror event
    });
  }

  closeDial(data?: any) {
    if (this.comm$) {
      this.comm$.next({ type: 'confirm', data });
    }
  }

  private clearPayIntentStorage() {
    const metaprov = parseInt(this.metadata_provenance);

    switch (metaprov) {
      case 1:
        this.tools.removeStor("ClientKeyPayIntentOrder");
        break;
      case 2:
        this.tools.removeStor("ClientKeyPayIntentCredit");
        break;
      case 3:
        this.tools.removeStor("ClientKeyPayIntentRefill");
        break;
      case 4:
        this.tools.removeStor("ClientKeyPayIntentNote");
        break;
      default:
        break;
    }
  }

}
